module.exports = __webpack_public_path__ + "static/media/AB_B2_4.b897cd3c.JPG";